import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatSort, Sort } from '@angular/material/sort';
import { states } from 'app/utilities/states';
import { fieldPatterns } from 'app/utilities/form.utilities';
import { AdminService } from 'app/services/admin.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { UserService } from 'app/users/user.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { AddNewUserRequest, ApplicationTableData, CreateOrgRequest, OrgData, RoleObject, UpdateAccessTypeRequest, UserData } from 'app/models/admin.model';
import { AccessTypesListAdmin} from 'app/models/data/mock/admin';
import { CountriesDisplayAndAPI, countryDisplayNameAndApiName } from 'app/utilities/countries';
import { FormService } from 'app/services/form.service';
import { ApplicationInfoModel } from 'app/models/application-info.model';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  user!: UserProfileRecord;
  userName!: string;
  showResults : boolean = false;
  isSmallView: boolean = false;
  screenSizeSubscription!: Subscription;
  dataSource = new MatTableDataSource<ApplicationTableData>();
  columnsToDisplay: string[] = ['form', 'contactName', 'firstSuggestedName', 'submittedDate', 'companyName', 'status', 'viewIcon'];
  columnsToDisplayForAssigned: string[] = ['form', 'contactName', 'firstSuggestedName', 'submittedDate',
    'negotiator', 'companyName', 'status', 'viewIcon']; 
  columnsToDisplayForDraft : string[] = ['form', 'contactName', 'firstSuggestedName', 'date', 'companyName', 'viewIcon'];
  @ViewChild(MatTable) table! : MatTable<any>;
  applicationData!: ApplicationTableData[];
  applicationsCount!: number;
  appTypes: string[] = ['New', 'Draft', 'Assigned', 'Approved / Closed'];
  loadingAppTypeComplete: boolean = false;
  assignedAppType: boolean = false;
  draftAppType: boolean = false;
  
  showUsers: boolean = false;
  loadingComplete: boolean = false;
  usersLoadingComplete: boolean = false;
  usersList = new MatTableDataSource<UserData>();
  userColumnsToDisplay: string[] = ['userName', 'companyName', 'email',  'accessType', 'status', 'change', 'remove'];
  userColumnsToDisplaySmallView: string[] = ['userName', 'companyName', 'accessType', 'detailsIcon'];
  orgId!: string;
  userId!: string;
  userEmail!: string;

  @ViewChild('editAccess') updateAccessDialog!: TemplateRef<any>;
  editAccessDialogRef!: MatDialogRef<any, any>;
  editAccessForm!: FormGroup;
  accessTypesList!: any;
  currentAccessType!: string;
  updateUserEmail!: string;
  userOrg!: string;

  @ViewChild('removeUser') removeUserDialog!: TemplateRef<any>;
  removeUserDialogRef!: MatDialogRef<any, any>;
  removeUserEmail!: string;
  removeUserName!: string;

  addUserForm!: FormGroup;
  addUserDialogRef!: MatDialogRef<any, any>;
  @ViewChild('addUser') addUserDialog!: TemplateRef<any>;
  addUserErrorMsg!: string;
  addUserHasError: boolean = false;
  addUserErrorEmail!: string;
  isAddUser: boolean = false;
  addOrgForm!: FormGroup;
  statesList = states;
  isAddOrg : boolean = false;
  userCompanyName : string = '';
  selectedOrg!: OrgData;
  showOrgResults : boolean = false;
  searchComplete : boolean = false;
  orgList !: OrgData[];
  noOrgResultsFound: boolean = false;
  loadingOrgsComplete : boolean = true;
  orgSelectionComplete: boolean = false;
  orgNameCheckForAdd: boolean = false;
  orgAddError:boolean = false;
  orgAddErrorMsg!: string;
  newOrgId!: string;
  orgCreated: boolean = false;
  

  @ViewChild(MatPaginator) admPaginator!: MatPaginator;
  appListLength: number = 0;
  defaultPageSize: number = 10;
  userListLength: number = 0;
  
  appCardData !: ApplicationTableData[];
  @ViewChild(MatPaginator) cardPaginator!: MatPaginator;
  pageCardSize: number = 5; 
  currentPage: number = 0;
  appCardDataPag !: ApplicationTableData[];

  @ViewChild(MatPaginator) usersAdminPaginator!: MatPaginator;
  userPageSize: number = 100;
  userCurrentPage: number = 0;
  userDataPag !: UserData[];
  userTableData !: UserData[];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatSort) usersSort!: MatSort;
  formTypeMap = { 
    'A': 'Form A - Single Entity Drug and Salt',
    'B': 'Form B - Single Entity' ,
    'C': 'Form C - Modified Salt Form' ,
    'D': 'Form D - USAN Revised Application' ,
    'E': 'Form E - Contact Lens Material' ,
    'F': 'Form F - Biologics' 
  };
 countries: CountriesDisplayAndAPI[] = countryDisplayNameAndApiName;
 private countrySub?: Subscription;

  constructor(private router: Router,
    private responsive: BreakpointObserver,
    private sortAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private adminService: AdminService,
    private formService: FormService,
    private alertService: AlertsService
  ) {}


  ngOnInit() {
    this.user = this.userService.profile;
    this.userName = this.user ? this.user.displayName : '';
    this.determineViewMode();
    this.retrieveApplications('New'); 
    this.retrieveUserData();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.paginator = this.admPaginator;
    }, 500); 
     
  } 

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.usersList.filter = filterValue.trim().toLowerCase();
  }

  applyApplicationFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if(!this.isSmallView) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      return
    }
    this.updateItemsForPagination(filterValue, true);
  }

  retrieveApplications(appType: string) {
      const request = {
        'ssoId': this.user.uniqueId,
        'status': [appType]
      }; 
      this.loadingComplete = false;
      this.showResults = false;
      this.adminService.getApplicationsForAdminDashboard(request).subscribe({
        next: res => {
         
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while retrieving data" + res.ErrorMessage);
            this.loadingComplete = true;
          } else {  
            if(res.Data) {
              //console.log('Response data length '+ res.Data.length)
              let results : ApplicationTableData[] = [];
              res.Data.forEach(element => {
                let appRecord : ApplicationTableData = {
                  date: element.opened_at,
                  firstSuggestedName: this.parseFormType(element.u_form_type) !='D'? element.u_suggested_names_in_order_of_preference_for_single_entity
                    :element.u_name_for_which_you_are_requesting_a_revision,
                  form:  this.parseFormType(element.u_form_type),
                  contactName: element.u_primary_contact_first_name + ' ' + element.u_primary_contact_last_name,
                  companyName: element.u_applicant,
                  sysId: element.caseSysId,
                  negotiator: element.negotiator?.name,
                  status: element.u_case_status,
                  submittedDate : element.u_application_submitted_date,
                  systemId: element.sys_id
                };
                results.push(appRecord);
              });
              this.dataSource.data = results;
              this.loadingComplete = true;
              this.showResults = true;
              this.cdr.detectChanges();
              this.dataSource.paginator = this.admPaginator;
              this.dataSource.sort = this.sort;
              this.dataSource.sortingDataAccessor = (data, sortColumn) =>{
                const dataValue = data[sortColumn];
                return typeof dataValue === 'string' ? dataValue.toLowerCase() : dataValue;
              }
              this.appListLength = results.length;
              if(this.isSmallView) {
                this.appCardData = results;
                this.updateItemsForPagination();
              }
            } 
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while retrieving data" + error.message);
          this.loadingComplete = true;
        }  
      }); 
  } 
  

  parseFormType(str: string) : string {
    if(str.includes('Form '))
      return str.split('Form ')[1];
    else if(str.includes('Form'))
      return str.split('Form')[1];
    return str;
  }

  retrieveUserData() {
      this.usersLoadingComplete = false;
      this.userEmail = this.user ? this.user.email : '';
      this.userId = this.user ? this.user.uniqueId : '';
      if(this.userEmail && this.userId) {
        this.adminService.getUsersForAdminDashboard(this.userEmail, this.userId).subscribe({
          next: res => {
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving user data" + res.ErrorMessage);
              this.usersLoadingComplete = true;
            } else {  
              if(res.Data) {
                //console.log('User data response '+ JSON.stringify(res.Data))
                let results : UserData[] = [];
                res.Data.forEach(element => {
                  //if(element.userStatus && element.userStatus === 'Active') { //Only Active users need to be displayed
                    let appRecord : UserData = {
                      userName: element.firstName + ' ' + element.lastName,
                      accessType: this.parseUsanAccessTypeArr(element.roles),
                      email: element.emailAddress,
                      orgId: element.orgId,  
                      companyName : element.companyName,
                      status: element.userStatus && element.userStatus.toUpperCase() === 'ACTIVE' ? 'Active' : 'Pending',
                    };
                    results.push(appRecord);
                  //}
                });
                this.showUsers = true;
                this.usersLoadingComplete = true;
                this.userListLength = results.length;
                this.userTableData = results;
                this.updateUserItemsForPagination();
              }
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving User data" + error.message);
            this.usersLoadingComplete = true;
          }  
        }); 
      } else {
        console.log('No email and uniqueId found for the user');
        this.usersLoadingComplete = true;
      }
    
  }

  parseUsanAccessType(str: string) : string {
    if(str && str.includes('USAN')) 
      return str.split('USAN ')[1];
    return str;
  }

  parseUsanAccessTypeArr(roles: any[]) : string {
    const roleNames =  roles
        .map(role => role.roleName.replace(/^USAN\s*/i, '')) 
        .join('/');
    return roleNames;
  }

  determineViewMode() {
    this.screenSizeSubscription = this.responsive.observe([Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait, Breakpoints.TabletLandscape 
    ])
        .subscribe(result => {
          const breakpoints = result.breakpoints;
          this.isSmallView = false;
          if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape] ||
            breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
            this.isSmallView = true;
          } 
        });
  }

  onPageChange(event: PageEvent) {
    this.pageCardSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updateItemsForPagination();
  }

  updateItemsForPagination(filterValue: string = '', resetPages: boolean = false) {
    let applicationData = new MatTableDataSource(this.appCardData);
    applicationData.filter = filterValue.trim().toLowerCase();
    
    // Since we're filtering, we need to update the pagination info.
    if(resetPages) {
      this.appListLength = applicationData.filteredData.length;
      this.cardPaginator.length = this.appListLength;
      this.currentPage = 0;
      this.cardPaginator.firstPage();
    }

    const start = this.currentPage * this.pageCardSize;
    const end = start + this.pageCardSize;
    this.appCardDataPag = applicationData.filteredData.slice(start, end);
    
  }

  shorten(name: string) : string {
    if(name && name.includes(' '))
      return name.charAt(0) + '.' + name.substring(name.indexOf(' ') + 1);
    return name;
  }

  viewDetails(row: any) {
    let appInfo = {
      formType: this.formService.prepFormTypeForUpdateCase(row.form),
      caseSysId: row.sysId,
      formId: row.systemId,
      status: row.status
    };
    
    if(row.status === 'Draft' || row.status === 'Payment Pending') {
      this.formService.lockCase(ApplicationInfoModel.parseValues(appInfo)).subscribe();
    }

    this.router.navigate(['/usan/application'], 
      { queryParams : { formType: row.form, id: row.sysId, source: 'admin-dashboard'}});
  }

  selectedTabChangeApp(appType: MatTabChangeEvent) {
    this.dataSource.data = [];
    this.loadingComplete = false;
    this.showResults = false;
    let appTypeSelected = this.appTypes[appType.index];
    if(appTypeSelected.includes('Approved'))
      appTypeSelected = 'Approved'; //Approved will also include Closed cases as well
    this.retrieveApplications(appTypeSelected);
    this.assignedAppType = false;
    this.draftAppType = false;
    if(appTypeSelected === 'Assigned')
      this.assignedAppType = true;
    if(appTypeSelected === 'Draft')
      this.draftAppType = true;
  }

  openEditAccessPopUp(element: any) {
    this.currentAccessType = '';
    this.accessTypesList = AccessTypesListAdmin;
    this.editAccessForm =  new FormGroup ({
      accessTypeSelected : new FormControl('USAN '+element.accessType, Validators.required)  
    });
    this.currentAccessType = 'USAN ' + element.accessType;
    this.updateUserEmail = element.email;
    this.userOrg = element.orgId
    this.editAccessDialogRef = this.dialog.open(this.updateAccessDialog, {
      width: '700px'
    });
  }

  get accessTypeField() {
    return this.editAccessForm.get('accessTypeSelected');
  }


  setNewAccessType(newVal: any) {
    this.accessTypeField?.setValue(newVal)
  }

  saveAccessTypeChange() {
    let newAccessType = this.accessTypeField?.value;
    if(newAccessType && this.currentAccessType &&
      newAccessType != this.currentAccessType) {
      let request : UpdateAccessTypeRequest = {
        orgId : this.userOrg,
        email : this.updateUserEmail,
        newRole : newAccessType,
        currentRole : this.currentAccessType
      }
      this.adminService.editAccess(request, this.userEmail, this.userId).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while updating User access" + res.ErrorMessage);
          } else {  
            this.alertService.displaySuccess("User access has been updated");
            this.retrieveUserData();
            this.editAccessDialogRef.close();
          }
          
        },
        error: error => {
          this.alertService.displayError("Error occurred while updating User access" + error.message);
        }  
      });
    } else {
      this.alertService.displayError("No changes found to update");
    }
  }

  cancelEdit() {
    this.editAccessDialogRef.close();
  }

  disableSaveBtn() {
    if(!this.editAccessForm.valid) 
      return true; 
    if(!this.editAccessForm.touched && this.editAccessForm.pristine) 
        return true; 
    if(this.accessTypeField?.value === this.currentAccessType)
      return true;
    return false;
  }

  removeUserConfirmPopUp(element: any) {
    this.removeUserDialogRef = this.dialog.open(this.removeUserDialog, {
      width: '312px'
    });
    this.removeUserEmail = element.email;
    this.removeUserName = element.userName;
    this.userOrg = element.orgId;
  }

  
  deleteUser() {
    if(this.removeUserEmail) {
      this.adminService.removeUser(this.userOrg, this.removeUserEmail, this.userEmail, this.userId).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while Removing User " + res.ErrorMessage);
          } else {  
            this.alertService.displaySuccess("User has been removed successfully");
            this.retrieveUserData();
            this.removeUserDialogRef.close();
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while Removing User " + error.message);
        }  
      });
    }
  }

  cancel() {
    this.removeUserDialogRef.close();
  }

  addNewUserPopup() {
    this.initializeAddUserForm();
    this.accessTypesList = AccessTypesListAdmin;
    this.addUserErrorEmail = '';
    this.resetOrgSearchFields();
    this.addUserHasError = false;
    this.addUserDialogRef = this.dialog.open(this.addUserDialog, {
      width: '700px'
    });
  }

  cancelOrgSearch() {
    this.cancelAdd();
  }

  disableSearchBtn() {
    if(!this.userCompanyName || this.userCompanyName.length < 4)
      return true;
    return false;
  }

  initializeAddUserForm() {
    this.addUserForm = this.formBuilder.group({
      firstName: [ '', Validators.required],
      lastName: [ '', Validators.required], 
      emailAddress: [ '', [Validators.required, Validators.email]],
      accessType: [ 'USAN Org Admin', Validators.required],
    });
  }

  searchForOrgName() {
    if(!this.orgNameCheckForAdd)
      this.loadingOrgsComplete = false;
    this.adminService.searchOrgByName(this.userCompanyName, this.userEmail, this.userId).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while searching for Company " + res.ErrorMessage);
        } else {  
          if(res.Data) {
            if(res.Data.length > 0) {
              let results = res.Data;
              this.orgList = [];
              results.forEach(element => {
                let org : OrgData = {
                  name : element.organizationName,
                  orgId : element.organizationId
                }
                this.orgList.push(org);
              });
              this.showOrgResults = true; 
            } else 
                this.noOrgResultsFound = true;
          }
        }
        this.searchComplete = true;
        this.loadingOrgsComplete = true;
      },
      error: error => {
        this.alertService.displayError("Error occurred while searching for company name" + error.message);
        this.searchComplete = true;
        this.loadingOrgsComplete = true;
      }  
    });  

  }

 
  selectingOrg( org: any) {
    this.orgSelectionComplete = true;
    this.selectedOrg = org;
    this.userCompanyName = org.name;
    this.orgId = org.orgId;
  }

  cancelOrgSelection() {
    this.resetOrgSearchFields();
  }

  retrieveOrgData() {

  }

  initializeAddOrgForm() {
    this.addOrgForm = this.formBuilder.group({
      orgName: [ this.userCompanyName, Validators.required],
      addrLine1: [ '', Validators.required], 
      addrLine2: [ ''],
      country: [ 'USA', Validators.required],
      city: [ '', Validators.required],
      state: [ '', Validators.required],
      zip: [ '', [Validators.required]],
      phone: [ '', [Validators.required, Validators.pattern(fieldPatterns.phoneNumber)]] 
    }); 
    this.countrySub?.unsubscribe(); 
    this.countrySub = this.addOrgForm.get('country')?.valueChanges.subscribe(country => {
      this.toggleStateField(country);
      this.togglePhoneValidation(country);
    });
  
    const initialCountry = this.addOrgForm.get('country')?.value;
    this.toggleStateField(initialCountry);
    this.togglePhoneValidation(initialCountry);
    this.addOrgForm.updateValueAndValidity();
  }

  toggleStateField(country: string) {
    this.addOrgForm.get('state')?.setValue('');
    this.addOrgForm.get('state')?.clearValidators();
    if (country === 'USA') {
        this.addOrgForm.get('state')?.setValidators(Validators.required);
    } 
    this.addOrgForm.get('state')?.updateValueAndValidity();
  }

  togglePhoneValidation(country: string) {
    const phoneControl = this.addOrgForm.get('phone');
    phoneControl?.clearValidators(); 
    if (country === 'USA') {
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(10),
        Validators.pattern(fieldPatterns.telephoneNumber) 
    ]);
    } else {
      phoneControl?.setValidators([
                      Validators.required,
                      Validators.pattern(fieldPatterns.telephoneNumber)
                    ]); 
    }
    phoneControl?.updateValueAndValidity();
  }
  
  disableAddBtn() {
    if(!this.addUserForm.valid) 
      return true; 
    if(!this.addUserForm.touched && this.addUserForm.pristine) 
      return true; 
    return false;
  }

  addNewUser() {
    let roleName : RoleObject = {
      roleName : this.addUserForm.get('accessType')?.value
    }
    let request : AddNewUserRequest = {
      firstName : this.addUserForm.get('firstName')?.value,
      lastName : this.addUserForm.get('lastName')?.value,
      emailAddress : this.addUserForm.get('emailAddress')?.value,
      role : [roleName]
    }
    this.addUserHasError = false;
    this.addUserErrorMsg = '';
    this.adminService.addNewUser(this.orgId, request, this.userEmail, this.userId).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while Adding New User " + res.ErrorMessage);
          this.addUserHasError = true;
          this.addUserErrorMsg = res.ErrorMessage;
        } else {  
          this.alertService.displaySuccess("User has been added successfully");
          this.retrieveUserData();
          this.addUserDialogRef.close();
        }
      },
      error: error => {
        let respError = error?.ErrorMessage; 
        this.addUserHasError = true;
        this.addUserErrorMsg = this.parseExceptionMessage(respError);
        this.addUserErrorEmail = this.addUserForm.get('emailAddress')?.value;
        this.alertService.displayError("Error occurred while Adding User " + error.message);
      }  
    }); 
  }

  parseExceptionMessage(errMsg : string) :string {
    if(errMsg?.includes(': "')) {
      let errorStr = errMsg.split(': "')[1];
      let errorObjStr = errorStr.substring(0, errorStr.length-1)
      let obj = JSON.parse(errorObjStr)
      return obj.ErrorMessage;
    }
    return errMsg;
  }

  cancelAdd() {
    this.addUserDialogRef.close();
    this.resetOrgSearchFields();
  }

  resetOrgSearchFields() {
    this.showOrgResults = false;
    this.noOrgResultsFound = false;
    this.searchComplete = false;
    this.userCompanyName = '';
    if(this.selectedOrg)
      Object.assign(this.selectedOrg, {});
    this.orgSelectionComplete = false;
    this.isAddOrg = false;
    this.isAddUser = true;
    this.orgCreated = false;
  }

  displayOrgCreationFields() {
    this.isAddOrg = true;
    this.isAddUser = false;
    this.initializeAddOrgForm();
    this.resetAddOrgFields();
  }

  disableAddOrgBtn() {
    if(!this.addOrgForm.valid) 
      return true; 
    if(!this.addOrgForm.touched && this.addOrgForm.pristine) 
      return true; 
    if(this.orgAddError)
      return true;
    return false;
  }

  addNewOrg() {  
    let request : CreateOrgRequest = {
      organizationName : this.addOrgForm.get('orgName')?.value,
      addressLine1 : this.addOrgForm.get('addrLine1')?.value,
      addressLine2 : this.addOrgForm.get('addrLine2')?.value,
      city : this.addOrgForm.get('city')?.value,
      state : this.addOrgForm.get('state')?.value,
      zipCode : this.addOrgForm.get('zip')?.value,
      phoneNumber : this.addOrgForm.get('phone')?.value
    }
    //check if the org already exists in OM
    this.orgNameCheckForAdd = true;
    this.resetAddOrgFields();
    let orgNameForAdd = request.organizationName;
    
    this.adminService.searchOrgByName(orgNameForAdd, this.userEmail, this.userId).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while searching for Company " + res.ErrorMessage);
        } else {  
          if(res.Data) {
            if(res.Data.length > 0) {
              this.orgAddErrorMsg = "A Company with this name already exists. Please enter new name.";
              this.orgAddError = true;
            } else 
              this.createNewOrg(request);
            
          }
        }
      },
      error: error => {
       this.alertService.displayError("Error occurred while searching for company name" + error.message);
      }  
    }); 
  }

  createNewOrg(request: CreateOrgRequest) {
    this.adminService.createOrg(this.userEmail, this.userId, request).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while creating new Company " + res.ErrorMessage);
          this.orgAddError = true;
          this.orgAddErrorMsg = res.ErrorMessage;
        } else {  
          if(res.Data) { 
            this.orgId = res.Data.organizationId;
            this.userCompanyName = res.Data.organizationName;
            console.log('Org created successfully' + this.orgId);
            this.isAddOrg = false;
            this.isAddUser = true;
            this.orgSelectionComplete = true;
            this.noOrgResultsFound = false;
            this.orgCreated = true;  
            this.resetAddUserFields();
          }
        }
      },
      error: error => {
        this.alertService.displayError("Error occurred while creating Company " + error.message);
      }  
    }); 
  }

  resetAddOrgFields() {
    this.orgAddError = false;
    this.orgAddErrorMsg = '';
    this.orgCreated = false;
  }

  resetAddUserFields() {
    this.addUserErrorMsg = '';
    this.addUserHasError = false;
    this.addUserForm.reset();
    this.addUserForm.get('accessType')?.setValue('USAN Org Admin');
  }

  onPageChangeForUsers(event: PageEvent) {
    this.userPageSize = event.pageSize;
    this.userCurrentPage = event.pageIndex;
    this.updateUserItemsForPagination();
  }

  updateUserItemsForPagination() {
      const start = this.userCurrentPage * this.userPageSize;
      const end = start + this.userPageSize;
      this.userDataPag = this.userTableData.slice(start, end);
      this.usersList.data = this.userDataPag;
  }

  ngOnDestroy(): void {
    this.screenSizeSubscription.unsubscribe();
    this.countrySub?.unsubscribe();
  }

  //to announce the change in sort state for assistive technology
  sortChangeUpdate(sortChange: Sort) {
    if(sortChange.direction) {
      this.sortAnnouncer.announce('Sorted '+ sortChange.direction);
    } else {
      console.log('Sort cleared');
      this.sortAnnouncer.announce('Sort cleared');
    }
  }

  userSortChangeUpdate(sortChange: Sort) {
    const data = [... this.userTableData];
    let column = sortChange.active;
    let dir = sortChange.direction;
    if (!column || dir === '') {
      //no change
      return;
    }
    const isAsc = dir ==='asc';
    this.userTableData = data.sort((a,b) => {
      let aValue = typeof a[column] === 'string' ? a[column].toLowerCase() : a[column];
      let bValue = typeof b[column] === 'string' ? b[column].toLowerCase() : b[column];
      return this.compareValues(aValue, bValue, isAsc);
      
    });
    this.updateUserItemsForPagination();
    if(sortChange.direction) {
      this.sortAnnouncer.announce('Sorted '+ sortChange.direction);
    } else {
      console.log('Sort cleared');
      this.sortAnnouncer.announce('Sort cleared');
    }
  }

  compareValues( a: string|number, b: string|number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}


